function App() {
  return (
    <div id="jumbotron">
      <div className="middle-container">
        <div className="main-box">
          <div className="box-header">
            <h1 className="header-name">Chris Marcok</h1>
            <h3 className="header-title">Software Developer</h3>
            <h3 className="header-location">Toronto, Ontario, Canada</h3>
            <a href="https://www.github.com/chrismarcok" target="_blank" rel="noreferrer" className="item-text">GitHub</a>{" | "}
            <a href="https://www.linkedin.com/in/chrismarcok" target="_blank" rel="noreferrer" className="item-text">LinkedIn</a>{" | "}
            <a href="/documents/Christopher_Marcok_Resume.pdf" target="_blank" rel="noreferrer" className="item-text">Resume</a>{" | "}
            <a href="/documents/Academic_History.pdf" target="_blank" rel="noreferrer" className="item-text">Transcript</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
